module.exports = __webpack_public_path__ + "static/media/saxo.36229a61.svg";